var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    width: 560,
    height: 560,
    role: "img",
    "aria-label": "Provider clinical workspace",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Provider clinical workspace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pvBg",
    x1: 1,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pvSide",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#011936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132C4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pvBar",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#257CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C3FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pvShadow",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 16,
    floodColor: "#011936",
    floodOpacity: 0.14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pvChip",
    x: "-45%",
    y: "-45%",
    width: "190%",
    height: "190%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 10,
    floodColor: "#011936",
    floodOpacity: 0.14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pvBlur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pvClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 280,
    r: 280
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pvCard"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 432,
    height: 336,
    rx: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pvClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 560,
    fill: "url(#pvBg)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 130,
    r: 98,
    fill: "#257CFF",
    opacity: 0.36,
    filter: "url(#pvBlur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 450,
    r: 102,
    fill: "#59C3FF",
    opacity: 0.38,
    filter: "url(#pvBlur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 70,
    fill: "#CFE2FF",
    opacity: 0.3,
    filter: "url(#pvBlur)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pvChip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 44,
    width: 240,
    height: 46,
    rx: 23,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 67,
    r: 13,
    fill: "#DCF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5 67h3l1.6-4 2.6 8 2-4h3.3",
    fill: "none",
    stroke: "#257CFF",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 64,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Cohort insight ready"), /*#__PURE__*/React.createElement("text", {
    x: 206,
    y: 77.5,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9.5,
    fill: "#7C8AA5"
  }, "248 matched patients"), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pvShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 432,
    height: 336,
    rx: 22,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pvCard)",
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 66,
    height: 336,
    fill: "url(#pvSide)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 140,
    r: 13,
    fill: "#ffffff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5 140h4l2-4.5 3 9 2.5-4.5h4",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 170,
    width: 42,
    height: 30,
    rx: 9,
    fill: "#ffffff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.9,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 181h12M91 185h12M91 189h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 218a6 6 0 1112 0M92 232h10M92 236h10",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 262l4-5 4 5 4-8",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 300h12M91 305h12M91 310h6",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 345,
    r: 6,
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 146,
    fontSize: 14,
    fontWeight: 700,
    fill: "#011936"
  }, "Patient cohort"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 162,
    fontSize: 10,
    fill: "#7C8AA5"
  }, "Urology &#183; Overactive bladder"), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 132,
    width: 98,
    height: 26,
    rx: 13,
    fill: "#F3F6FB",
    stroke: "#E7EDF7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 145,
    r: 4.6,
    fill: "none",
    stroke: "#5B7FA6",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.4 148.4l3.2 3.2",
    stroke: "#5B7FA6",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 357,
    y: 149,
    fontSize: 10,
    fill: "#9AA7BC"
  }, "Search"), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 132,
    width: 46,
    height: 26,
    rx: 13,
    fill: "#011936"
  }), /*#__PURE__*/React.createElement("text", {
    x: 459,
    y: 149,
    fontSize: 10,
    fontWeight: 600,
    fill: "#fff",
    textAnchor: "middle"
  }, "Share"), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 176,
    x2: 482,
    y2: 176,
    stroke: "#EDF1F7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 198,
    fontSize: 9,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "COHORT"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 217,
    fontSize: 17,
    fontWeight: 700,
    fill: "#011936"
  }, "248"), /*#__PURE__*/React.createElement("text", {
    x: 234,
    y: 198,
    fontSize: 9,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "RESPONDERS"), /*#__PURE__*/React.createElement("text", {
    x: 234,
    y: 217,
    fontSize: 17,
    fontWeight: 700,
    fill: "#011936"
  }, "71%"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 198,
    fontSize: 9,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "AVG. VISITS"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 217,
    fontSize: 17,
    fontWeight: 700,
    fill: "#011936"
  }, "3.4"), /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 198,
    fontSize: 9,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "TRIALS"), /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 217,
    fontSize: 17,
    fontWeight: 700,
    fill: "#011936"
  }, "6")), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 232,
    width: 332,
    height: 104,
    rx: 14,
    fill: "#F7FAFE",
    stroke: "#E9EFF8"
  }), /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 252,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Response by treatment arm"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 292,
    width: 20,
    height: 30,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 282,
    width: 20,
    height: 40,
    rx: 5,
    fill: "url(#pvBar)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 298,
    width: 20,
    height: 24,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 274,
    width: 20,
    height: 48,
    rx: 5,
    fill: "url(#pvBar)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 288,
    width: 20,
    height: 34,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 266,
    width: 20,
    height: 56,
    rx: 5,
    fill: "url(#pvBar)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 294,
    width: 20,
    height: 28,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 278,
    width: 20,
    height: 44,
    rx: 5,
    fill: "url(#pvBar)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 286,
    width: 20,
    height: 36,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 270,
    width: 20,
    height: 52,
    rx: 5,
    fill: "url(#pvBar)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: 322,
    x2: 468,
    y2: 322,
    stroke: "#E1E9F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 360,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Recent patients"), /*#__PURE__*/React.createElement("text", {
    x: 482,
    y: 360,
    fontSize: 9.5,
    fill: "#7C8AA5",
    textAnchor: "end"
  }, "View all"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 370,
    width: 332,
    height: 34,
    rx: 10,
    fill: "#F7FAFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 387,
    r: 11,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 383.4,
    r: 3.7,
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 393.6c1-3.5 3.5-5.2 6.2-5.2s5.2 1.7 6.2 5.2z",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 381,
    width: 76,
    height: 6,
    rx: 3,
    fill: "#C6D2E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 391,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#DDE5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 381,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#DDE5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 379,
    width: 62,
    height: 18,
    rx: 9,
    fill: "#EEF7EE"
  }), /*#__PURE__*/React.createElement("text", {
    x: 435,
    y: 391,
    fontSize: 9,
    fontWeight: 600,
    fill: "#2E9E45",
    textAnchor: "middle"
  }, "Improving")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 410,
    width: 332,
    height: 34,
    rx: 10,
    fill: "#F7FAFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 427,
    r: 11,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 423.4,
    r: 3.7,
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8 433.6c1-3.5 3.5-5.2 6.2-5.2s5.2 1.7 6.2 5.2z",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 421,
    width: 64,
    height: 6,
    rx: 3,
    fill: "#C6D2E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 431,
    width: 52,
    height: 5,
    rx: 2.5,
    fill: "#DDE5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 421,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#DDE5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 419,
    width: 62,
    height: 18,
    rx: 9,
    fill: "#DCF2FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 435,
    y: 431,
    fontSize: 9,
    fontWeight: 600,
    fill: "#257CFF",
    textAnchor: "middle"
  }, "Review"))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#pvChip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 470,
    width: 220,
    height: 46,
    rx: 23,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 493,
    r: 13,
    fill: "#EEF7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5 493l3.4 3.4 7.6-7.6",
    fill: "none",
    stroke: "#2E9E45",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 490,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 11.5,
    fontWeight: 600,
    fill: "#011936"
  }, "HIPAA &amp; GDPR ready"), /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 503.5,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9.5,
    fill: "#7C8AA5"
  }, "De-identified at source"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppProvider);
export default __webpack_public_path__ + "static/media/app-provider.f73e9b2ff6d348013db100e5c8d7c25e.svg";
export { ForwardRef as ReactComponent };